import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Text } from '@bingads-webui-react/fabric-control';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { PropertyRow } from '@bingads-webui-campaign-react/ui-generator';

export const formatConversionGoals = (i18n, conversionGoals) => {
  if (conversionGoals && conversionGoals.goalScopeSelection === 'account-scope') {
    return i18n.getString(_TL_('Account level conversion goals'));
  }

  const goalSelection = (conversionGoals && conversionGoals.goalSelection) || [];

  if (goalSelection.length === 1) {
    return i18n.getString(_TL_('1 conversion goal'));
  } else if (goalSelection.length > 1) {
    return i18n.getString(_TL_('{{count}} conversion goals'), { count: goalSelection.length });
  }

  return i18n.getString(_TL_('No conversion goals'));
};

export const ConversionGoals = ({ conversionGoals }) => {
  const i18n = useContext(I18nContext);

  return (
    <PropertyRow propertyLabel={{ label: _TL_('Conversion goals') }}>
      <Text>{formatConversionGoals(i18n, conversionGoals)}</Text>
    </PropertyRow>
  );
};

ConversionGoals.propTypes = {
  conversionGoals: PropTypes.shape({}),
};

ConversionGoals.defaultProps = {
  conversionGoals: null,
};
